import { render, staticRenderFns } from "./trainOutBaseList.vue?vue&type=template&id=1b1c6b42&scoped=true"
import script from "./trainOutBaseList.vue?vue&type=script&lang=js"
export * from "./trainOutBaseList.vue?vue&type=script&lang=js"
import style0 from "./trainOutBaseList.vue?vue&type=style&index=0&id=1b1c6b42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1c6b42",
  null
  
)

export default component.exports